import { useDispatch } from 'react-redux';
import { MessageDialog } from '../../dialog/message-dialog';
import { dialogActions } from '../../dialog/slice/dialog-slice';
import { localStorageActions } from '../../../slices/local-storage-slice';
import mockWarningImage from '../../../assets/img/warning/mock_stand_image_warning.jpg';
import snapixTWarningImage from '../../../assets/img/warning/SNAPix_T_image_warning.jpg';
import snapixYWarningImage from '../../../assets/img/warning/SNAPix_Y_image_warning.jpg';

/**
 * 商品ごとのレイアウト注意点ポップアップ設定
 * 商品が増えた場合はこの配列に1要素追加するだけで対応可能。
 * 「次回から表示しない」は商品IDごとに独立管理（localStorageキー: `${商品ID}_alert_message`）。
 * - ids      : 対象の商品ID（複数可）
 * - title    : 青帯の見出し
 * - comments : 青帯の本文（改行ごとに配列要素）
 * - image    : 注意画像。商品IDごとに出し分けたい場合は { 商品ID: 画像 } のマップで指定
 */
export type LayoutAnnotationConfig = {
  ids: string[],
  title: string,
  comments: string[],
  image: string | Record<string, string>,
};

export const layoutAnnotationList: LayoutAnnotationConfig[] = [
  // もっくスタンド
  {
    ids: ['jptg303312', 'jptg304233'],
    title: '【画像配置時の注意点】',
    comments: [
      '6枚両面（表・裏）の商品のため、入稿時は画像の並び順にご注意ください。',
      '1～6ページが表側：7～12ページが裏側になります。',
      '※7枚目の画像が１枚目の裏側に来る仕様です。',
    ],
    image: mockWarningImage,
  },
  // SNAPix（T:縦 / Y:横 で画像を出し分け）
  {
    ids: ['jptg306141', 'jptg306142'],
    title: '【レイアウト時の注意点】',
    comments: [
      '以下のフィルターの中からお選びいただけます',
      '画像を配置した際、フィルター加工は表示されませんのでご注意ください',
    ],
    image: {
      jptg306141: snapixTWarningImage, // SNAPix T
      jptg306142: snapixYWarningImage, // SNAPix Y
    },
  },
];

export const findLayoutAnnotation = (itemId: string): LayoutAnnotationConfig | undefined =>
  layoutAnnotationList.find((v) => v.ids.includes(itemId));

const resolveAnnotationImage = (annotation: LayoutAnnotationConfig, itemId: string): string =>
  typeof annotation.image === 'string' ? annotation.image : annotation.image[itemId];

type LayoutAnnotationDialogProps = {
  annotation: LayoutAnnotationConfig,
  itemId: string,
};

export const LayoutAnnotationDialog = ({ annotation, itemId }: LayoutAnnotationDialogProps) => {
  const dispatch = useDispatch();
  const image = resolveAnnotationImage(annotation, itemId);
  return (
    <div className="mock_stand_annotation__dialog">
      <header className="mock_stand_annotation__dialog__header">
        <div className="mock_stand_annotation__dialog__header__title">
          {annotation.title}
        </div>
        {annotation.comments.map((comment, i) => (
          <div className="mock_stand_annotation__dialog__header__cnt" key={`annotation-cnt-${i}`}>
            {comment}
          </div>
        ))}
      </header>
      <div className="mock_stand_annotation__dialog__img_wrap">
        <img className="mock_stand_annotation__dialog__img" src={image} alt="" />
      </div>
      <MessageDialog
        message={[]}
        className="mock_stand_annotation__dialog__footer"
        buttons={[{
          label: 'OK',
          callback: () => {
            dispatch(dialogActions.pop());
          },
        }]}
        remind={{
          callback: (v) => dispatch(localStorageActions.setIsStopAlertMessage({ productId: itemId, value: v })),
        }}
      />
    </div>
  );
};
